// Only define the component if it hasn't been defined yet
if (!customElements.get("tooltip-component")) {
  class TooltipComponent extends HTMLElement {
    constructor() {
      super();

      // Get references to elements
      this.tooltipLink = this.querySelector(".tooltip-link");
      this.tooltipModal = this.querySelector(".tooltip-modal");
      this.tooltipContent = this.querySelector(".tooltip-modal__content");
      this.tooltipClose = this.querySelector(".tooltip-modal__close");

      if (!this.tooltipLink || !this.tooltipModal || !this.tooltipContent)
        return;

      this.bindEvents();
    }

    bindEvents() {
      this.tooltipLink.addEventListener("click", (event) =>
        this.openModal(event)
      );
      this.tooltipModal.addEventListener("click", (event) =>
        this.handleModalClick(event)
      );
      this.tooltipClose.addEventListener("click", (event) =>
        this.closeModal(event)
      );
      document.addEventListener("keydown", (event) => this.handleEscKey(event));
    }

    openModal(event) {
      event.preventDefault();
      this.tooltipModal.style.display = "block";
      this.tooltipLink.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("modal-open");
    }

    closeModal() {
      this.tooltipModal.style.display = "none";
      this.tooltipLink.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("modal-open");
    }

    handleModalClick(event) {
      if (event.target === this.tooltipModal) {
        this.closeModal();
      }
    }

    handleEscKey(event) {
      if (
        event.key === "Escape" &&
        this.tooltipModal.style.display === "block"
      ) {
        this.closeModal();
      }
    }

    // Lifecycle callbacks
    connectedCallback() {
      if (!this.isInitialized) {
        this.isInitialized = true;
      }
    }

    disconnectedCallback() {
      // Clean up event listeners if component is removed
      this.tooltipLink?.removeEventListener("click", this.openModal);
      this.tooltipModal?.removeEventListener("click", this.handleModalClick);
      document.removeEventListener("keydown", this.handleEscKey);
    }
  }

  // Register the custom element
  customElements.define("tooltip-component", TooltipComponent);
}
